import React from 'react';
import { useTheme } from 'styled-components';

import type { KeyStatsCoursesVariants } from 'Theme/types/components.type';

import BasicKeyStat, { BasicKeyStatProps } from 'Components/KeyStat/Basic';

import Grid, { Col } from 'Components/Grid';

import { Wrapper, CourseContainer, Heading, Text, Link } from './Course.styled';
import { LinkProps } from 'Elements/Link';

interface CourseProps extends BasicKeyStatProps {
    id: string;
}

export interface Props {
    sectionID: string;
    keyStats: CourseProps[];
    heading: string;
    text: string;
    headingType?: 'h2' | 'h3';
    link?: LinkProps;
    courseType?: KeyStatsCoursesVariants;
}

const Course: React.FC<Props> = props => {
    const {
        sectionID,
        heading,
        keyStats,
        text,
        link,
        headingType = 'h2',
        courseType = 'undergraduate'
    } = props;

    const { colors, components } = useTheme();

    const statColours = components.keyStatsCourse[courseType].colours;

    return (
        <Wrapper id={sectionID}>
            <Grid>
                <Col h={6}>
                    <Heading as={headingType}>{heading}</Heading>
                    <Text>{text}</Text>
                    {link && <Link {...link} />}
                </Col>
                <Col h={6}>
                    <CourseContainer>
                        {keyStats.map(({ id, ...props }, index) => (
                            <li key={id}>
                                <BasicKeyStat
                                    {...props}
                                    backgroundColor={colors.tertiary.hex}
                                    statColor={statColours[index % statColours.length]}
                                    textColor={colors.primaryContrast.hex}
                                />
                            </li>
                        ))}
                    </CourseContainer>
                </Col>
            </Grid>
        </Wrapper>
    );
};

export default Course;
